/** @file Component-wise product of two packed RGBA8 colour words, rounded to nearest. */

/** p × q per channel (bytes R,G,B,A of `math/color.pack` words), each round(x·y/255); returns a uint32. */
export function tintWord(p: number, q: number): number {
  const r = (((p & 255) * (q & 255) + 127) / 255) | 0;
  const g = ((((p >>> 8) & 255) * ((q >>> 8) & 255) + 127) / 255) | 0;
  const b = ((((p >>> 16) & 255) * ((q >>> 16) & 255) + 127) / 255) | 0;
  const a = (((p >>> 24) * (q >>> 24) + 127) / 255) | 0;
  return (r | (g << 8) | (b << 16) | (a << 24)) >>> 0;
}
